import { Layer } from 'types';
import { CapitolaClient } from './base';

export default class LayerClient extends CapitolaClient<Layer> {
  public get resourceName(): string {
    return 'layer';
  }
}
